export default ({ req }, inject) => {
  // Функция для определения домена
  const getTitleCityByHost = () => {
    let host = '';
    if (process.server) {
      host = req?.headers?.host || '';
    } else {
      host = window?.location?.host || '';
    }

    if (host.includes('msk')) {
      return ' в Москве';
    }
    if (host.includes('spb')) {
      return ' в Санкт-Петербурге';
    }
    if (host.includes('novosibirsk')) {
      return ' в Новосибирске';
    }
    if (host.includes('ekb')) {
      return ' в Екатеринбурге';
    }
    if (host.includes('kazan')) {
      return ' в Казани';
    }
    if (host.includes('nnv')) {
      return ' в Нижний Новгороде';
    }
    if (host.includes('chelyabinsk')) {
      return ' в Челябинске';
    }
    if (host.includes('ufa')) {
      return ' в Уфе';
    }
    if (host.includes('samara')) {
      return ' в Самаре';
    }
    if (host.includes('rostov')) {
      return ' в Ростове-на-Дону';
    }

    return '';
  };

  inject('getTitleCityByHost', getTitleCityByHost);
};
